import React from 'react'

import UserPage from './UserPage'

import { AppBar, Avatar, Tabs, Tab, Box } from '@design/pt-ui'

import { AdminFilterHook } from './Filter'
import UserTable from './UserTable'
import { translateWithUserLocale } from '../../utils/i18n'

interface TabPanelProps {
  children?: React.ReactNode
  index: any
  value: any
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && (
        <Box p={3}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  )
}

function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

export type UserPageLayoutProps = {
  adminFilter: AdminFilterHook
}

export default function UserPageLayout(props: UserPageLayoutProps) {
  const [value, setValue] = React.useState(0)

  const handleChange = (_event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue)
  }

  const selectedUser = props.adminFilter.state.selectedUser

  return (
    <div style={{ flexGrow: 1, backgroundColor: 'inherit' }}>
      {selectedUser === null ? (
        <div
          style={{
            display: 'flex',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 32,
          }}>
          <h3>{translateWithUserLocale('user.management_user_info_text')}</h3>
        </div>
      ) : (
        <>
          <div
            style={{
              display: 'flex',
              width: '100%',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              paddingTop: 35,
              paddingBottom: 25,
            }}>
            <div style={{ marginRight: 15 }}>
              <Avatar src="">
                {`${selectedUser.firstName[0]}${selectedUser.lastName[0]}`}
              </Avatar>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <h3
                style={{
                  paddingBottom: 0,
                  marginBottom: 0,
                  paddingTop: 0,
                  marginTop: 0,
                }}>
                {`${selectedUser.firstName} ${selectedUser.lastName}`}
              </h3>
            </div>
          </div>
          <AppBar
            elevation={0}
            color="inherit"
            position="static"
            sx={{ width: '98%' }}>
            <Tabs
              value={value}
              indicatorColor="primary"
              onChange={handleChange}
              sx={{ paddingLeft: '15px', paddingRight: '15px' }}
              aria-label="simple tabs example">
              <Tab
                label={translateWithUserLocale(
                  'user.management_user_page_permissions_tab',
                )}
                {...a11yProps(0)}
              />
              <Tab
                label={translateWithUserLocale(
                  'user.management_user_page_permissions_table',
                )}
                {...a11yProps(1)}
              />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <UserPage adminFilter={props.adminFilter} />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <UserTable adminFilter={props.adminFilter} />
          </TabPanel>
        </>
      )}
    </div>
  )
}
